<div class="card tpo-report-card" style="min-height: 199px;">
  <div class="card-body d-flex flex-column justify-content-center">
    <div class="panel-group">
      <div class="row align-items-stretch">
        <div class="col-md-6 col-sm-6 col-xs-6"
          [ngClass]="application ? 'border-end border-right-loan-status' : 'col-md-12'">
          <loan-status-card
            [loanStatusName]="loanStatus?.tpoStatusAlias || loanStatus?.loanStatusName || 'Unknown'"
            [subStatusName]="subStatus ? subStatus.subStatusName : null "
            >
          </loan-status-card>
        </div>
        @if (application) {
          <div class="col-md-6 col-sm-6 col-xs-6">
            <outstanding-conditions-card
              [appId]="application.applicationId"
              [isTpoSubmitted]="isTpoSubmitted"
              [primaryBorrowerId]="application.primaryBorrowerId">
            </outstanding-conditions-card>
          </div>
        }
      </div>
    </div>
  </div>
</div>
